import AppWrapper from 'AppWrapper'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

if (process.env.NODE_ENV === 'production') {
  const noConsole = (): void => {}
  console.log = noConsole
  console.info = noConsole
  console.warn = noConsole
  console.error = noConsole
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AppWrapper />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)
